import dayjs from 'dayjs';
const customParseFormat = require('dayjs/plugin/customParseFormat');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const DATE_FORMATS = [
    'MM/DD/YYYY HH:mm:ss',
    'YYYY-MM-DD HH:mm:ss',
    'MM/DD/YYYY',
    'YYYY-MM-DD',
    'YYYYMMDD',
];

export const formatDate = (date, outputFormat?) => {
    let parsedDate;
    let usedFormat;
    for (const format of DATE_FORMATS) {
        parsedDate = dayjs(date, format, true);
        if (parsedDate.isValid()) {
            usedFormat = format;
            break;
        }
    }

    if (!parsedDate.isValid()) {
        console.error('Invalid date format');
        return null;
    }

    const localDate = dayjs.tz(parsedDate, dayjs.tz.guess());
    return localDate.format(outputFormat || usedFormat);
};

export const hasExpired = (date: string) => {
    const today = dayjs();
    const endDate = dayjs(date);
    return today.isAfter(endDate);
}